var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-row',{staticClass:"ma-15",attrs:{"justify":"space-around"}},[_c('v-col',{attrs:{"cols":"12","md":"5","sm":"12"}},[_c('v-img',{staticClass:"blob",attrs:{"src":require("@/assets/fichee.svg")}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }